module.exports = __webpack_public_path__ + "static/media/Info.c3cd3b26.svg";